import type { BaseObject, BaseProperty, RecordMode } from './Base';
import { type TableFilterData } from './Base';
import { type DataType } from './MW';
export type Questionnaire = BaseObject & {
  title: string;
  description: string;
  bindingType: number | null;
  effectiveFromDate: string;
  effectiveUpToDate: string;
  sequence: number;
  mwQuestionnaireType: string;
  listColumns: number;
  isStandards: boolean;
  traderGroupId: string;
  assortmentId?: string;
  assortment?: string;
  qstActionId?: string;
  action?: BaseProperty;
  traderGroup?: string;
  eBindingTypeString?: string;
  createUser?: { userName: string; name: string };
  updateUser?: { userName: string; name: string };
  questions?: QstQuestionDetails[];
  groupItem?: string;
  bindingId?: string;
  createdDate?: string;
  groupItemId?: string;
};

export type QstTableFilterData = TableFilterData & {
  isStandards?: boolean;
};

export enum eBindingType {
  Generic = 0,
  Material_groups = 1,
  Materials = 2,
}

export type Question = BaseObject & {
  title: string;
  description?: string;
  mwDataTypeId: string;
  mwDataType?: DataType;
  image?: string;
  sort?: number;
  allowNull: boolean;
  qstListId?: string;
  qstList?: QstList;
  isIncludeLastVisitData: boolean;
  qstQuestionnaireId: string;
  createUser?: { userName: string; name: string };
  updateUser?: { userName: string; name: string };
  qstQuestionnaire?: {
    id: string;
    title?: string;
    description?: string;
    mwQuestionnaireType?: string;
    bindingType?: number;
  };
  questionnaireType?: string;
  questionnaireName?: string;
  halo?: number;
  lalo?: number;
};

export type QstQuestionDetails = BaseObject & {
  id: string;
  title: string;
  description: string;
  includeLastVisitData?: number | boolean;
  sort?: number;
  halo?: number;
  lalo?: number;
  allowNull?: number | boolean;
  listId?: string | null;
  listDescription?: string | null;
  listMultiSelect?: number | boolean | null;
  qstListRow?: QstListRow[];
  qstList?: QstList;
  groupItemName?: string;
  groupItemId?: string;
  materialId?: string;
  materialName?: string | undefined;
  answer?: string;
  prototypeData?: any;
  historicActionDetail?: QstActionDetail | null;
  hasAction?: boolean;
  savedTransactionDetailId?: string;
  mwDataType: DataType;
  image?: string;
};

export type QstList = {
  id: string;
  multiSelect?: boolean;
  qstListRows?: QstListRow[];
  isActive?: boolean;
  isFromManager?: boolean;
  createdDate?: string;
};

export type QstListRow = {
  id: string;
  description: string;
  image?: string;
  qstListId: string;
  sort: number;
  isActive?: boolean;
  isFromManager?: boolean;
  createdDate?: string;
  modified?: boolean;
};

export type QstActionDetail = BaseObject & {
  qstActionId: string;
  description: string;
  sequence: number;
  isSettled: boolean;
};

export type QstQuestionnairePrototype = {
  id: string;
  isActive: boolean;
  isFromManager: boolean;
  description: string;
  qstQuestionId: string;
  qstQuestionnairePrototypeData: QstQuestionnairePrototypeData[];
};

export type QstQuestionnairePrototypeData = {
  id: string;
  isActive: boolean;
  isFromManager: boolean;
  materialGroupItemId: string;
  materialId?: string;
  prototypeDataMaterialGroup?: GroupItemPrototype;
  condition?: string;
  acceptedValue?: string;
  recommendedValue?: string;
  perfectValue?: string;
  qstQuestionnairePrototypeId: string;
  recordMode?: RecordMode;
};

export type GroupItemPrototype = {
  id: string;
  fullName?: string;
  parentGroupItemId?: string;
  materialId?: string;
  materialName?: string;
};
